import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

import Button from '@/components/button'
import TableSkeleton from '@/components/table-skeleton'
import { useGetInfestationReports } from '@/hooks/queries/use-get-infestation-reports'

import { EmptyComponent } from '../../components/empty-component'
import { Row } from './row'
import { useStyles } from './styles'

interface ReportsListProps {
  openForm: () => void
}

export function ReportsList({ openForm }: ReportsListProps) {
  const classes = useStyles()

  const { data, isPreviousData, isFetching } = useGetInfestationReports()

  const isFetchingMore = (isPreviousData && isFetching) || !data

  return data && data.length === 0 ? (
    <>
      <Box display='flex' justifyContent='flex-end'>
        <Button onClick={openForm} className={classes.button}>
          <AddIcon />
          Novo relatório
        </Button>
      </Box>
      <EmptyComponent
        title='Nenhum relatório disponível'
        subtitle='Não há nenhum relatório contendo seus indicadores de infestação disponível.  Solicite um relatório'
      />
    </>
  ) : (
    <>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Typography variant='h1'>Relatórios de infestação</Typography>
        <Button onClick={openForm} className={classes.button}>
          <AddIcon />
          Novo relatório
        </Button>
      </Box>
      <Box height='100%' overflow='auto'>
        <Table padding='none' className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Data de solicitação
                </Typography>
              </TableCell>

              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Nome do relatório
                </Typography>
              </TableCell>

              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Período dos resultados
                </Typography>
              </TableCell>

              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Solicitante
                </Typography>
              </TableCell>

              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Cultura(s)
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='h3' color='textSecondary'>
                  Status
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          {isFetchingMore ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={6}>
                  <TableSkeleton />
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {data?.map((row) => (
                <Row key={row.id} row={row} />
              ))}
            </TableBody>
          )}
        </Table>
      </Box>
    </>
  )
}
